// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Modal-ModalFooter-module--cls1--My6Km","cls2":"Modal-ModalFooter-module--cls2--2O0TW Modal-ModalFooter-module--cls1--My6Km"};